import { GET_PERSONAL_ACCOUNT_INFO, GET_PERSONAL_ACCOUNTS } from "./types";

export default {
  [GET_PERSONAL_ACCOUNT_INFO]: (state, accountInfo) => {
    state.personalAccountInfo = accountInfo;
  },

  [GET_PERSONAL_ACCOUNTS]: (state, accounts) => {
    state.personalAccounts = accounts.results;
  }
};
